<template>
  <div>
    <div class="product-add">
      <!--form表单-->
      <el-form size="small" label-width="150px">
        <div class="common-form">加钟设置</div>
        <el-form-item label="技师比例（%）">
          <el-input v-model="obj.waiter" placeholder="技师比例" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="商户比例（%）">
          <el-input v-model="obj.supplier" placeholder="商户比例（%）" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="平台比例（%）">
          <el-input v-model="obj.shop" placeholder="平台比例（%）" class="max-w460"></el-input>%
        </el-form-item>

      </el-form>
    </div>
    <div class="common-button-wrapper">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </div>
  </div>
</template>

<script>
import fareApi from "@/api/fare.js";
export default {
  data() {
    return {
      obj: {}
    };
  },
  created() {
    this.getDate();
  },
  methods: {
    getDate() {
      let self = this;
      fareApi.AddClockindex({}, true)
        .then(res => {
          self.obj = res.data
        })
        .catch(err => {});
    },
    onSubmit() {
      let self = this;
      fareApi.AddClockedit(self.obj, true)
        .then(res => {
          if (res.code == 1) {
            this.$message({
              message: res.msg,
              type: "success"
            });
          }
          console.log(res);
        })
        .catch(err => {
          this.$message({
            message: err.msg,
            type: "warning"
          });
        });
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/setting/isclock/index.vue